// GENERATED CODE - DO NOT MODIFY BY HAND

import * as m from '@april9au/stack9-sdk';
import { z } from 'zod';

import { Organisation } from './Organisation';
import { Topic } from './Topic';

export const ResourceTypeOptionSet = [
  'Article',
  'Document',
  'External Link',
  'Vimeo',
] as const;
export const ResourceTypeOptionType = z.enum(ResourceTypeOptionSet);
export type ResourceTypeOptionType = z.infer<typeof ResourceTypeOptionType>;

export const Resource = z.object({
  resource_type: ResourceTypeOptionType,
  slug: m.ZTextField,
  title: m.ZTextField,
  resource_thumbnail: m.ZFileField.optional().nullable(),
  thumbnail_summary: m.ZTextField.optional().nullable(),
  is_active: m.ZCheckbox.optional().nullable(),
  is_public: m.ZCheckbox.optional().nullable(),
  order: m.ZNumericField.optional().nullable(),
  published_date: m.ZDateField.optional().nullable(),
  expiry_date: m.ZDateField.optional().nullable(),
  keywords: m.ZTextField.optional().nullable(),
  feature_on_homepage: m.ZCheckbox.optional().nullable(),
  featured_start_date: m.ZDateField.optional().nullable(),
  featured_end_date: m.ZDateField.optional().nullable(),
  featured_order: m.ZNumericField.optional().nullable(),
  file_to_be_downloaded: m.ZFileField.optional().nullable(),
  vimeo_video_id: m.ZTextField.optional().nullable(),
  video_transcript: m.ZTextField.optional().nullable(),
  external_url: m.ZTextField.optional().nullable(),
  content: m.ZRichTextEditor.optional().nullable(),
});
export type Resource = z.infer<typeof Resource>;

export const ResourceWithRelated = Resource.extend({
  available_to_organisations: z.array(Organisation),
  topics: z.array(Topic),
  related_articles: z.array(Resource),
});
export type ResourceWithRelated = z.infer<typeof ResourceWithRelated>;

export const DBResource = m.ZEntityInterface.merge(Resource);
export type DBResource = z.infer<typeof DBResource>;
